import DynamicForm, { FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { useCreateDataPointValues, useGetDataPointValues } from 'api/hooks/useDataPointValues';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import DynamicFormWrapper from 'components/DynamicFormWrapper';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { CONTINUE_ONLINE_ADVERSE_DRIVING_PATH } from 'routes/constants';
import useSelector from 'store/useSelector';

import schema from './schema';
import { FormValues } from './types';

const INTERVIEW_URNS: Array<keyof FormValues> = [
  'urn:pg:data-point:insured-risk-activity-criminal-conviction',
  'urn:pg:data-point:insured-risk-activity-criminal-conviction-date',
  'urn:pg:data-point:insured-risk-activity-criminal-conviction-description',
  'urn:pg:data-point:insured-risk-activity-criminal-conviction-recently-discharged',
];

const CriminalHistory: React.FC = () => {
  const activeUserUuid = useSelector((app) => app.activeUserUuid);
  const navigate = useNavigate();

  const { createDataPointValuesFromInterview } = useCreateDataPointValues({
    onCompleted: () => {
      completedNavigatorStep(StepName.CRIMINAL_HISTORY, activeUserUuid);

      navigate(`../${CONTINUE_ONLINE_ADVERSE_DRIVING_PATH}`);
    },
  });

  const { data, loading } = useGetDataPointValues({ params: { urns: INTERVIEW_URNS } });

  const onSubmit = async (values: FormValuesOutput<FormValues>) => {
    await createDataPointValuesFromInterview(values, schema);
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent>
      <DynamicFormWrapper>
        <DynamicForm<FormValues>
          name="criminal-history"
          schema={schema}
          onSubmit={onSubmit}
          initialValues={data?.dataPointValues}
        />
      </DynamicFormWrapper>
    </NavigatorContent>
  );
};

export default CriminalHistory;
